// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"e46e2d96","276":"4d2ae0e0","453":"03346f77","777":"f059aff4","902":"7c0ea8b6"}[chunkId] + ".chunk.js";
};